import { FC } from 'react'
import clsx from 'clsx'

import Button from '../button/button'

import ButtonThemes from '../button/themes'
import { A_subLector, lectorOrigin } from 'utils/analytics/other/sub_lector/sub_lector'

import styles from './btn-lectur-subscribe.module.scss'

interface IBtnLecturSubscribe {
  isSubscribed: boolean
  idLector: number
  theme?: ButtonThemes
  overrideText?: string
  origin?: string
}

const BASE_TEXT = 'Подписаться'

const BtnLecturSubscribe: FC<IBtnLecturSubscribe> = ({
  isSubscribed,
  theme,
  overrideText,
  origin,
  idLector,
}: IBtnLecturSubscribe) => {
  const finalText = overrideText || BASE_TEXT
  const analyticsHandler = () => {
    origin && A_subLector(origin as lectorOrigin, String(idLector))
  }
  return (
    <>
      <Button
        theme={theme}
        onClick={analyticsHandler}
        modificator={clsx(styles.subscribeBtn, {
          [styles.subscribed]: isSubscribed,
        })}
      >
        <div className={styles.btnContent}>
          {!isSubscribed && <span>{finalText}</span>}
          <div
            className={clsx(styles.toggleButtonPlus, {
              [styles.blueLine]: theme === ButtonThemes.SECOND,
            })}
          >
            <div className={styles.toggleButtonPlusLine} />
            <div className={clsx(styles.toggleButtonPlusLine, styles.toggleButtonPlusLine2)} />
          </div>
        </div>
      </Button>
    </>
  )
}

export default BtnLecturSubscribe
